$(function () {

  ev();

  var menuItems = {
    project: {
      "red": {
        name: "No requirement"
      },
      "orange": {
        name: "Ramp up"
      },
      "green": {
        name: "Project work"
      }
    },
    candidate: {
      "red": {
        name: "Busy"
      },
      "orange": {
        name: "Ask me"
      },
      "green": {
        name: "Available"
      }
    }
  };
  if (document.getElementById('ForPeople') || document.getElementById('ForProject')) {

    $.contextMenu({
      selector: '#ForProject .context-menu-one .box-date-candidate',
      callback: function (key, options) {
        var m = key;
        updateStatusDates(m);
      },
      items: menuItems.project,

    });

    $.contextMenu({
      selector: '#ForPeople .context-menu-one .box-date-candidate',
      callback: function (key, options) {
        var m = key;
        updateStatusDates(m);

      },
      items: menuItems.candidate,
    });

  } else {
    isProject = $(".bl-calendar").hasClass("launchNewProjectCalendar");
      var curentDates = $(".infoDate ").val();
    $.contextMenu({
      selector: '.context-menu-one .box-date-candidate',
      callback: function (key, options) {
        var m = key;
        updateStatusDates(m);
          removeDisabledBtn();
          $(".calendar-error").hide();

          if (document.getElementById('addCandidate') && document.getElementById('isEdit')) {
              if (CALENDAR_INPUT != curentDates) {
                  curentDates = CALENDAR_INPUT;
                  data = {
                      name: $(".infoDate ").attr('name'),
                      value: $(".infoDate ").val(),
                      is_part_edit: true
                  };
                  $.when(postRequest(data, "/Register/Candidate/Set"))
                      .done(function (answer) {
                          }
                      );
              }
          };

          if (document.getElementById('createProject') && document.getElementById('isEdit')) {

              if (CALENDAR_INPUT != curentDates) {
                  curentDates = CALENDAR_INPUT;
                  data = {
                      name: $(".infoDate ").attr('name'),
                      value: $(".infoDate ").val(),
                      is_part_edit: true,
                      project_id:$("#createProject").attr("data-project-id"),
                  };
                  $.when(postRequest(data, "/Profile/Employer/Project/Create"))
                      .done(function (answer) {
                          }
                      );
              }
          }

      },
      items: isProject ? menuItems.project : menuItems.candidate,

    });
  }

  function validCalendar() {
      if(document.getElementById('createProject') && $('#duration').is(':checked')){
          return false;
      }

    var fullDate = $(".infoDate").val();
    fullDate = JSON.parse(fullDate);
      var tmp=0;
      jQuery.each(fullDate[0]["Data"], function(i, val) {
          if(val["status"]=="green"){
            tmp=1;
          }
      });

    if (!tmp && !document.getElementById('addCandidate')) {
      $(".calendar-error").show();
      addDisabledBtn();
    } else {
      removeDisabledBtn();
      $(".calendar-error").hide();
    }
  }

  addDisabledBtn = () => {
    $(".button-cloud").attr("disabled", "disabled");
  }
  ;

  removeDisabledBtn = () => {
    $(".button-cloud").removeAttr("disabled");
  }
  ;

    //=================request============================

    function postRequest(data, route) {
        var d = $.Deferred();
        $.ajax({
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken
                },
                url: route,
                data: data,
                dataType: 'json',
                type: 'POST',
            }
        ).done(function (result) {
            var answer = result.answer;
            d.resolve(answer);
        }).fail(d.reject);
        return d.promise();
    }
});